import { useHistory } from 'react-router-dom';

export function useGoToPath() {
  const history = useHistory();
  const go = ({ path, isRedirect = false }) => {
    return isRedirect ? history.replace(path) : history.push(path);
  };
  return { go };
}
